import { Form, Formik } from "formik";
import React, { useEffect, useState, useMemo } from "react";

import { toast } from "react-toastify";
import { Grid, Divider } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import InnerForm from "./children/InnerForm";
import {
  linkVaultInitialValues,
  linkVaultValidationSchema,
} from "./children/LinkVaultHelpers";
import LinkVaultPreview from "./children/LinkVaultPreview";
import { selectProfile } from "../../../../../redux/reducers/gallery";
import { useUserUpdateProfile } from "../../../../../services/mutations";
import { updateProfile as updateProfileReducer } from "../../../../../redux/reducers/gallery";

const LinkVault = ({ initialValues, onClose }) => {
  const [apiLoading, setApiLoading] = useState(false);
  const profile = useSelector(selectProfile);
  const dispatch = useDispatch();
  const updateProfile = useUserUpdateProfile();

  const onSubmitHandler = async (values, formikHelpers) => {
    formikHelpers.setSubmitting(true);
    setApiLoading(true);

    const payload = {
      user_profile: {
        external_links: values.external_links,
      },
    };

    updateProfile.mutate(payload, {
      onSuccess: (response) => {
        setApiLoading(false);
        dispatch(updateProfileReducer({ updates: response?.data }));
        formikHelpers.resetForm({ values });
        formikHelpers.setSubmitting(false);
        toast.success("LinkVault updated successfully!");
      },
      onError: (err) => {
        setApiLoading(false);
        formikHelpers.setSubmitting(false);
        toast.error("Some error occurred!");
      },
    });
  };

  return (
    <Formik
      initialValues={initialValues || linkVaultInitialValues}
      onSubmit={onSubmitHandler}
      enableReinitialize
      validateOnMount
      validationSchema={linkVaultValidationSchema}
    >
      {({ values }) => (
        <Form>
          <Grid
            container
            sx={{
              height: "86vh",
            }}
          >
            <Grid
              xs={7}
              item
              style={{
                height: "calc(100% - 100px)",
              }}
              sx={{
                overflowY: "auto !important",
                flexShrink: 0,
              }}
            >
              <InnerForm onClose={onClose} apiLoading={apiLoading} />
            </Grid>

            {/* Vertical Divider */}
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                mx: "10px",
                color: "#BBBBBB",
                opacity: 1,
                height: "calc(100% - 100px)",
              }}
            />

            {/* Preview section */}
            <Grid
              item
              xs={4.5}
              style={{ height: "calc(100% - 100px)" }}
              sx={{
                width: "100%",
                overflowY: "auto !important",
                overflowX: "hidden",
                flexShrink: 0,
                // height: "700px",
                //maxWidth: "400px",
                px: "10px",
              }}
            >
              <LinkVaultPreview links={values?.external_links} />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default LinkVault;
